import React from 'react'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import Timeline, {TimelineItemBody, TimelineItemHeader} from '../Timeline'

export const NonMemberPlusTimeline = () => (
  <Timeline>
    <TimelineItemHeader>
      <FormattedMessageWrapper
        id="membership.howItWorks.signInToSave"
        defaultMessage="1. Sign in to save"
      />
    </TimelineItemHeader>
    <TimelineItemBody>
      <FormattedMessageWrapper
        id="membership.howItWorks.memberOnlyDiscounts"
        defaultMessage="Create a FindHotel account to access great Member only discounts at properties around the world."
      />
    </TimelineItemBody>

    <TimelineItemHeader>
      <FormattedMessageWrapper
        id="membership.howItWorks.stayAndUpgrade"
        defaultMessage="2. Stay and upgrade"
      />
    </TimelineItemHeader>
    <TimelineItemBody>
      <FormattedMessageWrapper
        id="membership.howItWorks.plusMembershipAfterCompletingFirstStay"
        defaultMessage="After completing your first stay as a FindHotel Member you’ll automatically be upgraded to Plus status, unlocking even bigger discounts at properties around the world."
      />
    </TimelineItemBody>

    <TimelineItemHeader>
      <FormattedMessageWrapper
        id="membership.howItWorks.keepSaving"
        defaultMessage="3. Keep saving"
      />
    </TimelineItemHeader>
    <TimelineItemBody isLastStep>
      <FormattedMessageWrapper
        id="membership.howItWorks.plusMembershipNeverExpires"
        defaultMessage="Your Plus Member status never expires, so you’ll always have access to the best accomodation – only available here on FindHotel."
      />
    </TimelineItemBody>
  </Timeline>
)
